export const fadeImages = [
    {
        url: require('../components/images/jujutsu1.png'),
    },
    {
        url: require("../components/images/jujutsu2.png"),
    },
    {
        url: require("../components/images/tanjiro.png"),
    },
    {
        url: require("../components/images/zenitsu.png"),
    },
    // {
    //     image: "/images/react-one.jpg",
    //     title: 'Merch',
    //     description: "Test",
    //     id: 4
    // },
    // {
    //     image: "/images/react-one.jpg",
    //     title: 'Merch',
    //     description: "Test",
    //     id: 5
    // },
    // {
    //     image: "/images/react-one.jpg",
    //     title: 'Merch',
    //     description: "Test",
    //     id: 6
    // },
    // {
    //     image: "/images/react-one.jpg",
    //     title: 'Merch',
    //     description: "Test",
    //     id: 7
    // },
];

// export default {
//     Merch
// }